import axios from 'axios';

export const client = axios.create({
    baseURL: process.env.REACT_APP_SKYCOMMS_API,
    withCredentials: true
})

// Global error handler: suppress unhandled network rejections
client.interceptors.response.use(
    (response) => response,
    (error) => {
        if (!error.response) {
            // Network Error — CORS, DNS, or connectivity failure
            console.warn('[API] Network Error — server unreachable or CORS blocked');
        }
        return Promise.reject(error);
    }
);
